import { NewPageComponent } from './../../templates/new-page/new-page.component';
import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { ActivatedRoute } from '@angular/router';
import { ExtraService } from '../../core/services/extra.service';
import { DropDownComponent } from '../../layout/drop-down/drop-down.component';
import { from } from 'rxjs/observable/from';
import { NewPageList } from '../../core/models/new-page-list';
import { ListWithinList } from '../../core/models/list-within-list';
import { Constants } from '../../core/config/Constants';


@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css'],
  providers: [ExtraService]
})
export class AboutUsComponent {

  public page = {
    title: "About Us",
    slug: "About"
  };

  constructor() {

  }



}






// WEBPACK FOOTER //
// /app/src/app/event/about-us/about-us.component.ts